module.exports = __webpack_public_path__ + "static/img/loginCenter.9c853e0b.png";